import { render } from "./BlckAddFile.vue?vue&type=template&id=1e8b46ac&scoped=true"
import script from "./BlckAddFile.vue?vue&type=script&lang=js"
export * from "./BlckAddFile.vue?vue&type=script&lang=js"

import "./BlckAddFile.vue?vue&type=style&index=0&id=1e8b46ac&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8b46ac"]])

export default __exports__